import "core-js/features/array/find";
import "core-js/features/array/includes";
import "core-js/features/object/entries";
import "core-js/features/object/keys";
import "core-js/features/string/includes";
import React from "react";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/doublestruck-bootstrap.scss";
import "./css/main-styles.css";
import { unregister } from "./registerServiceWorker";
import { createRoot } from "react-dom/client";
import { startGoogleTagManager } from "./utils/googleTagManager";
import brandConfig from "./utils/brandConfig";
import getUrlParams from "./utils/getUrlParams";

/* GTM Stuff */
const getBrand = () => {
  const urlParams = getUrlParams();
  if (urlParams && urlParams.brand) {
    return brandConfig.find(item => item.brand === urlParams.brand);
  } else {
    // default to exampro if the param is not set in the URL for Brand
    return brandConfig[1];
  }
};
startGoogleTagManager(getBrand().brand);

/*const tagManagerArgs = {
    gtmId: (getBrand().brand == "TB" ? "GTM-NLR78P" : "GTM-K9X7RX")
  }
  console.log('init gtm');
  TagManager.initialize(tagManagerArgs);*/
  
  const container = document.getElementById('root');
  const root = createRoot(container); 
  root.render(<App />);

// If you want your app to work offline and load faster, you can need to
// uncomment the line below AND replace the import above with:  import registerServiceWorker, { unregister } from "./registerServiceWorker";
// Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA

// registerServiceWorker();
unregister();
